import React from 'react'
import { Create } from 'react-admin'

import PageForm from './form'

export const PageCreate = (props) => (
  <Create {...props}>
    <PageForm {...props} />
  </Create>
)

export default PageCreate
